export default "__VITE_ASSET__B2R8CO5a__"